import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function WhyItFailedSection() {
  const reasons = ['Los analgésicos solo apagan la alarma, pero no apagan el incendio que ocurre en tu columna.', 'El descanso total debilita tus músculos de soporte, haciendo que el próximo ataque sea más fuerte.', 'Los estiramientos de gimnasio suelen comprimir más los discos si no se hacen con el ángulo correcto.', 'Ignorar el dolor está creando una memoria de inflamación crónica que será más difícil de borrar después.'];
  return <section className="py-16 md:py-24 bg-white" data-id="element-214">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-215">
        <FadeIn data-id="element-216">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-teal-900 mb-12 text-center" data-id="element-217">
            Por qué lo que has intentado no funciona
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-218">
          {reasons.map((reason, index) => <FadeIn key={index} delay={index * 0.1} direction="up" data-id="element-219">
              <div className="flex items-start gap-4 p-6 bg-cream-50 rounded-xl border border-cream-200 h-full" data-id="element-220">
                <XCircle className="w-6 h-6 text-coral flex-shrink-0 mt-1" data-id="element-221" />
                <p className="text-gray-700 text-lg leading-relaxed" data-id="element-222">
                  {reason}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}